import { all, call, put, takeLatest } from 'redux-saga/effects'
import saveAs from 'file-saver'
import agent, { mocked } from 'agent'
import appMode from 'helpers/getAppMode'

import * as actions from 'redux/actions/list.actions'

function* getListsSaga() {
  try {
    let endpoint = agent.Lists.getAll
    if (appMode.preview) {
      endpoint = mocked.Lists.getAll
    }
    const body = yield call(endpoint)
    const lists = body.data

    yield put(actions.getListsSuccess(lists))
  } catch (error) {
    yield put(actions.getListsFailure(error))
  }
}

function* getListSaga(params) {
  try {
    const { id } = params.payload
    let endpoint = agent.Lists.get
    if (appMode.preview) {
      endpoint = mocked.Lists.get
    }
    const body = yield call(endpoint, id)
    const list = body.data

    yield put(actions.getListSuccess(list))
  } catch (error) {
    yield put(actions.getListFailure(error))
  }
}

function* deleteListSaga(params) {
  try {
    const { id } = params.payload
    yield call(agent.Lists.del, id)
    yield put(actions.deleteListSuccess())

    // Refresh the lists
    yield put(actions.getLists())
  } catch (error) {
    yield put(actions.deleteListFailure(error))
  }
}

function* deleteListKeywordsSaga(params) {
  try {
    const { id, filters, keywordIds } = params.payload
    yield call(agent.Lists.deleteKeywords, id, keywordIds)

    // Refresh the lists
    yield put(actions.getList(id, filters))
    yield put(actions.deleteListKeywordsSuccess())
  } catch (error) {
    yield put(actions.deleteListKeywordsFailure(error))
  }
}

function* addListSaga(params) {
  try {
    const { payload } = params.payload
    const body = yield call(agent.Lists.create, payload)
    if (body?.data?.id) {
      // add items to list
      yield call(agent.Lists.update, body.data.id, payload)
    }

    yield put(actions.getLists())

    yield put(actions.addListSuccess())
  } catch (error) {
    yield put(actions.addListFailure(error))
  }
}

function* updateListSaga(params) {
  try {
    const { id, payload } = params.payload
    yield call(agent.Lists.update, id, payload)
    yield put(actions.getLists())
    yield put(actions.updateListSuccess())
  } catch (error) {
    yield put(actions.updateListFailure(error))
  }
}

function* exportListSaga(params) {
  try {
    const { id } = params.payload
    const response = yield call(agent.Lists.export, id)
    yield call(saveAs, response, `export-keywords-${Date.now()}.csv`)
  } catch (error) {
    // eslint-disable-next-line
    console.warn(error)
  }
}

export default function* listSagas() {
  yield all([
    takeLatest(actions.getLists.type, getListsSaga),
    takeLatest(actions.getList.type, getListSaga),
    takeLatest(actions.deleteList.type, deleteListSaga),
    takeLatest(actions.deleteListKeywords.type, deleteListKeywordsSaga),
    takeLatest(actions.addList.type, addListSaga),
    takeLatest(actions.updateList.type, updateListSaga),
    takeLatest(actions.exportList.type, exportListSaga)
  ])
}
